import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from 'actions/notificationActions';

// Transfer redux notifications to SnackbarProvider
const SnackbarNotifier: React.FC = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [displayed, setDisplayed] = useState<Array<number | string>>([]);
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state: ApplicationState) => state.notification.notifications || [],
  );

  const storeDisplayed = (id: number | string) => {
    setDisplayed((displayed) => [...displayed, id]);
  };

  const removeDisplayed = (id: number | string) => {
    setDisplayed((displayed) => [...displayed.filter((key) => id !== key)]);
  };

  useEffect(() => {
    notifications.forEach(
      ({ key, message, options = {}, dismissed = false }) => {
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
          return;
        }

        // do nothing if snackbar is already displayed
        if (displayed.includes(key)) return;

        // display snackbar using notistack
        enqueueSnackbar(message, {
          key,
          ...options,
          onClose: (event, reason, myKey) => {
            if (options.onClose) {
              options.onClose(event, reason, myKey);
            }
          },
          onExited: (event, myKey) => {
            // remove this snackbar from redux store
            dispatch(removeSnackbar(myKey));
            removeDisplayed(myKey);
          },
        });

        // keep track of snackbars that we've displayed
        storeDisplayed(key);
      },
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export default SnackbarNotifier;
